import React from 'react';
import { SvgProps, Svg } from '../../Svg';

const Icon: React.FC<SvgProps> = props => {
  return (
    <Svg
      width="13"
      height="13"
      viewBox="0 0 13 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M8.46304 4.63736L7.4553 4.60291L7.23682 10.1642L8.24456 10.1986L8.46304 4.63736Z"
        fill="#787876"
      />
      <rect
        x="5.50531"
        y="4.62012"
        width="1.00839"
        height="5.56137"
        fill="#787876"
      />
      <path
        d="M4.78213 10.1641L4.56365 4.60272L3.55591 4.6372L3.77441 10.1985L4.78213 10.1641Z"
        fill="#787876"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.00891113 3.24151V2.30157H12.0089V3.24151H10.9412L10.1076 12.0711C10.0849 12.3137 9.86673 12.5 9.60538 12.5H2.39545C2.13412 12.5 1.91612 12.3139 1.89326 12.0712L1.05967 3.24151H0.00891113ZM2.85782 11.5601H9.14422L9.9296 3.24152H2.07261L2.85782 11.5601Z"
        fill="#787876"
      />
      <path
        d="M7.65661 0.5H4.36248C3.89912 0.5 3.52216 0.851375 3.52216 1.28328V2.77154H4.53055V1.43994H7.48855V2.77154H8.49694V1.28328C8.49694 0.851375 8.11997 0.5 7.65661 0.5Z"
        fill="#787876"
      />
    </Svg>
  );
};

export default Icon;
